import { render, staticRenderFns } from "./AssessmentButton.vue?vue&type=template&id=3f149793&scoped=true&"
import script from "./AssessmentButton.vue?vue&type=script&lang=ts&"
export * from "./AssessmentButton.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentButton.vue?vue&type=style&index=0&id=3f149793&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f149793",
  null
  
)

export default component.exports